import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * TabBar 与页面转场。
 *
 * TabBar 的两个必需项：
 * - **底部安全区**。不加的话在带 Home Indicator 的机型上，标签被那条横杠压着，点不准。
 * - **未读角标降级**。系统角标不可用（桌面浏览器、iOS 未装到主屏）时，站内也必须能看到
 *   未读——"不支持角标"不等于"用户就该看不到未读"。
 *
 * 页面转场用 View Transitions API，不支持的浏览器**直接不做动画**而不是退化成一个
 * 半吊子的 CSS 动画：一个不跟手的转场比没有转场更廉价。
 */
import { useCallback } from 'react';
export function TabBar({ items, active, onChange, className = '' }) {
    return (_jsxs("nav", { className: `ps-tabbar ${className}`.trim(), role: "tablist", "aria-label": "\u4E3B\u5BFC\u822A", children: [items.map((item) => {
                const isActive = item.key === active;
                return (_jsxs("button", { type: "button", role: "tab", "aria-selected": isActive, "data-ps-pressable": "", className: `ps-tab ${isActive ? 'ps-active' : ''}`.trim(), onClick: () => onChange(item.key), children: [_jsxs("span", { className: "ps-tab-icon", children: [isActive ? (item.activeIcon ?? item.icon) : item.icon, item.dot && !item.badge ? (_jsx("span", { className: "ps-tab-dot", "aria-hidden": "true" })) : item.badge ? (_jsx("span", { className: "ps-tab-badge", "data-ps-number": "", "aria-label": `${item.badge} 条未读`, children: item.badge > 99 ? '99+' : item.badge })) : null] }), _jsx("span", { className: "ps-tab-label", children: item.label })] }, item.key));
            }), _jsx("div", { className: "ps-tabbar-safe" })] }));
}
/**
 * 用 View Transitions API 包一次路由切换。
 *
 * ```tsx
 * const transition = useViewTransition()
 * transition('forward', () => navigate('/detail/1'))
 * ```
 *
 * 不支持的浏览器直接同步执行，不做动画。
 */
export function useViewTransition() {
    return useCallback((kind, update) => {
        const doc = typeof document === 'undefined' ? null : document;
        if (!doc || kind === 'none' || typeof doc.startViewTransition !== 'function') {
            update();
            return;
        }
        doc.documentElement.dataset['psTransition'] = kind;
        const vt = doc.startViewTransition(() => {
            update();
        });
        void vt.finished.finally(() => {
            delete doc.documentElement.dataset['psTransition'];
        });
    }, []);
}
export function NavBar({ title, left, right, align = 'center', className = '' }) {
    return (_jsxs("header", { className: `ps-navbar ps-navbar-${align} ${className}`.trim(), children: [_jsx("div", { className: "ps-navbar-side ps-navbar-left", children: left }), _jsx("div", { className: "ps-navbar-title ps-truncate", children: title }), _jsx("div", { className: "ps-navbar-side ps-navbar-right", children: right })] }));
}
//# sourceMappingURL=navigation.js.map